export const onNewEventifyEvent = (): void => {
    window.open('/eventify/newEvent', '_blank');
};
